var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`status__pill text-center${_vm.smallWidth}${_vm.bgColor} ${_vm.cls}`},[_vm._v(" "+_vm._s(_vm.titleCase(_vm.renderStatus(_vm.status)))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }